/**
 * Lazy Load Images Script
 *
 * This script initializes lazy loading for images with the "lazy-load-image" class
 * once the DOM content is fully loaded. It selects all images with the specified class
 * and provides a placeholder for additional functionality to be added for managing
 * lazy loading behavior.
 *
 * Usage:
 * Add the class "lazy-load-image" to any <img> tag you want to be lazy-loaded.
 * Ensure this script is included in your HTML so that it runs after the page has loaded.
 */

console.log("Lazy Load Images Initialized");

document.addEventListener("DOMContentLoaded", function () {
  const _el = {
    images: document.querySelectorAll("img.lazy-load-image"),
  };

  const _fn = {
    /**
     * Initializes the lazy load images functionality.
     * Creates an IntersectionObserver that observes each image,
     * and if the image is intersecting with the viewport, the data-src attribute
     * is swapped with the src attribute.
     * @param {Object} options - Options object.
     * @param {IntersectionObserver} options.observer - IntersectionObserver instance.
     * @param {HTMLElement[]} options.images - Array of images to observe.
     */
    init: function () {
      const Observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setImageSource({ img: entry.target, observer });
          }
        });
      });

      _el.images.forEach((img) => {
        Observer.observe(img);
      });
    },
    /**
     * Checks if the viewport is at most 768px wide.
     * @returns {boolean} True if the viewport is at most 768px wide, false otherwise.
     */
    isMobile: function () {
      return window.matchMedia("(max-width: 768px)").matches;
    },
    /**
     * Sets the source of an image based on the viewport size.
     * If the viewport is at most 768px wide and there is a data-src-mobile attribute set on the image,
     * the data-src-mobile attribute is swapped with the src attribute.
     * Otherwise, the data-src attribute is swapped with the src attribute.
     * The IntersectionObserver is then unobserved from the image.
     * @param {Object} options - Options object.
     * @param {HTMLElement} options.img - Image element to set source for.
     * @param {IntersectionObserver} options.observer - IntersectionObserver instance.
     */
    setImageSource: function ({ img, observer }) {
      if (_fn.isMobile() && img.dataset.srcMobile) {
        img.src = img.dataset.srcMobile;
      } else {
        img.src = img.dataset.src;
      }
      observer.unobserve(img);
    },
  };

  _fn.init();
});
